<script setup lang="ts">
  import { computed } from 'vue';
  import { HoverListTooltip } from '@/shared/ui';
  import type { PhysicalLocationOverflowDisplay } from '../model/physical-location-overflow';

  const props = defineProps<{
    display: PhysicalLocationOverflowDisplay;
  }>();

  const title = computed(
    () => `${props.display.items.length !== 1 ? 'Locais' : 'Local'} (${props.display.items.length})`
  );
</script>

<template>
  <span v-if="!display.hasTooltip" class="text-sm text-gray-07">{{ display.countLabel }}</span>
  <HoverListTooltip
    v-else
    :label="display.countLabel"
    :title="title"
    :items="display.items"
    test-id="physical-locations-tooltip"
  />
</template>
